<template>
    <button :disabled="disabled" class="glassy-button" :class="{ 'my-button-disabled': disabled }">
      <slot></slot>
    </button>
  </template>
  
  <script setup>
  import { defineComponent, ref, defineProps } from 'vue';
  
  const text = ref('');
  const props = defineProps({
    disabled: Boolean
  });
  // export default defineComponent({
  //   name: 'Button'
  // });
  </script>
  
  <style scoped>
  .glassy-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    padding: 0.9rem 1.2rem;
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 16px;
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.04)),
      rgba(20, 26, 52, 0.32);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    color: white;
    font-size: 0.98rem;
    font-weight: 600;
    letter-spacing: 0.01em;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.08),
      0 10px 24px rgba(5, 10, 22, 0.18);
    transition:
      background-color 0.25s ease,
      border-color 0.25s ease,
      transform 0.2s ease,
      box-shadow 0.25s ease;
  }
  
  .glassy-button:not(:disabled):hover {
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.14), rgba(255, 255, 255, 0.06)),
      rgba(24, 31, 60, 0.4);
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.1),
      0 14px 28px rgba(5, 10, 22, 0.22);
  }

  .glassy-button:not(:disabled):active {
    transform: translateY(1px);
  }
  
  /* .glassy-button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.4);
  } */
/*   
  .glassy-button:active {
    background-color: rgba(255, 255, 255, 0.4);
  } */

  .my-button-disabled {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.45);
    cursor: not-allowed;
    box-shadow: none;
  }
  </style>
  
